import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./AltScheduleColumn.scss";
import AltScheduleSlot from "../AltScheduleSlot/AltScheduleSlot";
import ModalComponent from "../../UI/ModalComponent/ModalComponent";
import AltSlotForm from "../../Slot/AltSlotForm/AltSlotForm";

const AltScheduleColumn = ({
    element,
    slots,
    specialists,
    salons,
    currentSchedule,
    selectSlotsAction = null,
    specialistsLeaves
}) => {
    const positions = useSelector(state => state.specialists.positions);
    const [openModalId, setOpenModalId] = useState(null);
    const [isSelected, setIsSelected] = useState(false);

    const hoverColumn = () => {
        setIsSelected(true);
    };

    const leaveColumn = () => {
        setIsSelected(false);
    };

    const closeModal = () => {
        setOpenModalId(null);
    }

    const openModal = (specialistId) => {
        setOpenModalId(specialistId);
    }

    const renderSlot = (specialist, index) => {
        
        const isLeaveDay = specialistsLeaves?.[specialist.id]?.[element.customDate];

        if (!currentSchedule) {
            return <div
                className={"alt-schedule-column__slots-cell-item" + (isLeaveDay ? ` ${isLeaveDay}` : "")}
                data-row-id={specialist.id}
                key={index}
            />;
        }

        const currentSlot = slots.find(
            item => item.worker_id === specialist.id &&
                item.date_format === element.customDate
        );

        if (currentSlot) {
            const salon = salons.find(salon => salon.id == currentSlot.site_id);
            const position = positions.find(position => position.id == currentSlot.position);

            return (
                <div
                    className={"alt-schedule-column__slots-cell-item"  + (isLeaveDay ? ` ${isLeaveDay}` : "")}
                    data-row-id={specialist.id}
                    key={index}
                >
                    <AltScheduleSlot
                        slot={currentSlot}
                        salon={salon}
                        position={position}
                        selectSlotsAction={selectSlotsAction}
                    />
                </div>
            );
        }
        return (
            <div
                className={"alt-schedule-column__slots-cell-item" + (isLeaveDay ? ` ${isLeaveDay}` : "")}
                data-row-id={specialist.id}
                key={index}
            >
                <ModalComponent
                    isOpen={openModalId === specialist.id}
                    isSlotsForm={true}
                    button={<div className="add-slot__button" onClick={() => openModal(specialist.id)}></div>}>
                    <AltSlotForm
                        closeModal={closeModal}
                        date={element.customDate}
                        listId={currentSchedule}
                        specialist={specialist}
                    />
                </ModalComponent>
            </div>
        );


    };

    return (
        <div
            className={"alt-schedule-column" + (isSelected ? " selected" : "")}
        >
            <div
                className="alt-schedule-column__header"
                onMouseEnter={hoverColumn}
                onMouseLeave={leaveColumn}
            >
                <span>{element.weekDay}</span>
                {element.dateStr}
            </div>
            <div className="alt-schedule-column__slots">
                {specialists.map((specialist, index) => {

                    return renderSlot(specialist, index);
                })}
            </div>
        </div>
    );
};

export default AltScheduleColumn;